export default function decibelToVolume(decibel) {
	return Math.pow(2, decibel / 6);
}
